(() => {
  const config=document.querySelector('[data-heary-analytics]');
  if(!config || window.Shopify?.designMode) return;
  const pageType=config.dataset.pageType;
  const environment=config.dataset.themeRole==='main'?'production':'test';
  let allowed=false, pageSent=false, clarityLoaded=false, clarityStopped=false;
  const campaign={};
  const query=new URLSearchParams(location.search);
  for(const key of ['source','medium','campaign','content','term']) {
    const value=query.get('utm_'+key);
    if(value && /^[a-zA-Z0-9_.-]{1,100}$/.test(value)) campaign[key]=value;
  }
  const sentDepth=new Set();
  function emit(name, data={}) {
    if(!allowed || !window.Shopify?.analytics?.publish) return;
    window.Shopify.analytics.publish('heary:'+name,{page_type:pageType,environment,campaign,...data});
    if(clarityLoaded) window.clarity('event','heary_'+name);
  }
  window.hearyTrack=emit;
  function consent() {
    allowed=window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;
    if(!allowed) { if(clarityLoaded) {window.clarity('consentv2',{analytics_Storage:'denied',ad_Storage:'denied'});window.clarity('stop');clarityStopped=true;} return; }
    if(!pageSent && window.Shopify?.analytics?.publish){emit('page_view');pageSent=true;}
    if(clarityLoaded && clarityStopped){window.clarity('start');window.clarity('consentv2',{analytics_Storage:'granted',ad_Storage:'denied'});clarityStopped=false;}
    if(!clarityLoaded) {
      document.body.setAttribute('data-clarity-mask','true');
      window.clarity=window.clarity || function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
      window.clarity('consentv2',{analytics_Storage:'granted',ad_Storage:'denied'});
      window.clarity('set','heary_page',pageType);
      window.clarity('set','environment',environment);
      const script=document.createElement('script');script.async=true;script.src='https://www.clarity.ms/tag/z4eabrzo7p';document.head.appendChild(script);clarityLoaded=true;
    }
  }
  document.addEventListener('visitorConsentCollected',consent);
  if(window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)consent();});
  let attempts=0;
  const ready=setInterval(()=>{consent();if(pageSent || ++attempts>30)clearInterval(ready);},1000);
  document.addEventListener('click',event=>{
    const link=event.target.closest('a');if(!link)return;
    if(pageType==='advertorial') {
      const url=new URL(link.href,location.origin);
      if(url.origin===location.origin && (['tryheary','heary-product-b'].includes(url.searchParams.get('view'))||url.pathname.includes('/products/heary-'))) emit('advertorial_cta_click',{cta_position:[...document.querySelectorAll('a')].indexOf(link)+1});
    }
    if(link.closest('[data-th-dialog]') && link.href.includes('/checkout'))emit('checkout_click');
  });
  window.addEventListener('scroll',()=>{
    const total=document.documentElement.scrollHeight-window.innerHeight;
    const percent=total>0?window.scrollY/total*100:100;
    for(const depth of [25,50,75,90]) if(allowed && percent>=depth && !sentDepth.has(depth)){sentDepth.add(depth);emit('scroll_depth',{percent_scrolled:depth});}
  },{passive:true});
})();
